import { CreateShipmentForm } from './components/CreateShipmentForm';

import '../shipping-details/Shipment.css';

export const CreateShipmentPage = () => {
  return (
    <div className="common-page shipping-page">
      <CreateShipmentForm />
    </div>
  );
};
